import { render, staticRenderFns } from "./input-doc.vue?vue&type=template&id=dc1a6e8a&"
import script from "./input-doc.vue?vue&type=script&lang=js&"
export * from "./input-doc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports